import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import GetQuoteButton from "../components/GetQuoteButton";
import Projects from "../data/projects";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const Sectors = () => {
  const [activeTab, setActiveTab] = useState("Our Projects");

  const renderProjectCards = (projects, isWorkDone = false) => (
    <div className="project-list">
      {projects.map((project) => (
        <a
          key={project.id}
          href={isWorkDone ? project.Link : project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="project-card-updated"
        >
          {/* Main Image */}
          <div className="main-image-section">
            <img
              src={
                Array.isArray(project.mainImages)
                  ? project.mainImages[0]
                  : project.mainImages
              }
              alt={project.title}
              className="main-project-image"
            />
          </div>


          {/* Text Section */}
          <div className="project-details">
            <h2 className="project-title">{project.title}</h2>
            {/* Completed at Port Badge */}
            {(project.location?.toLowerCase().includes("colombo") ||
              project.location?.toLowerCase().includes("hambantota") || 
              project.location?.toLowerCase().includes("galle")) && (
                <span className="location-badge">
                  Completed at {project.location.includes(",")
                    ? project.location.split(",")[0]
                    : project.location}
                </span>
              )}
            <p className="project-project">{project.project}</p>

            {/* Vessel & Location */}
            {(project.vessel || project.location) && (
              <div className="project-meta">
                {project.vessel && (
                  <p className="project-vessel">
                    <strong>Vessel:</strong> {project.vessel}
                  </p>
                )}
                {project.location && (
                  <p className="project-location">
                    <strong>Location:</strong> {project.location}
                  </p>
                )}


              </div>
            )}

            {/* Description */}
            <div className="project-description">
              {Array.isArray(project.description) ? (
                project.description.map((line, index) => (
                  <p key={index}>{line}</p>
                ))
              ) : (
                <p>{project.description}</p>
              )}
            </div>
          </div>

          {/* Additional Images */}
          <div className="additional-images-grid">
            {project.additionalImages?.slice(0, 4).map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${project.title} extra ${index + 1}`}
                className="thumbnail-image"
              />
            ))}
          </div>
        </a>
      ))}
    </div>
  );

  return (
    <>
      <div>
        <Navbar />

        <div className="sectors-container">
          {/* Our Sectors */}
          <h1 className="sectors-title">Our Sectors</h1>

          <div className="sector-cards">
            <Link to="/sectors/marine" className="sector-card marine-bg">
              <h2>Marine Engineering Services</h2>
              <p>Professional Maintenance and Overhauls of Marine Engines and systems</p>
            </Link>

            <Link to="/sectors/docking" className="sector-card docking-bg">
              <h2>Pre-Docking Solutions</h2>
              <p>Resolving issues in CPP systems and Fixed Propeller.</p>
            </Link>

            <Link to="/sectors/shipbuild" className="sector-card shipbuild-bg">
              <h2>Ship & Boat Building</h2>
              <p>Custom Steels and Pipeline Fabrication handled by expert teams.</p>
            </Link>

            <Link to="/sectors/husbandry" className="sector-card husbandry-bg">
              <h2>Husbandry Services</h2>
              <p>Servicing of Domestic and Industrial refrigeration Systems Onboard</p>
            </Link>

            <Link to="/sectors/spares" className="sector-card spares-bg">
              <h2>Spares & Store Supply</h2>
              <p>Troubleshooting Boiler, Motor and LT Cooler Control Circuits</p>
            </Link>

            <Link
              to="/sectors/industrial"
              className="sector-card industrial-engineering-bg"
            >
              <h2>Industrial Engineering</h2>
              <p>Customize sourcing Certified marine equipment’s and accessories</p>
            </Link>
          </div>

          {/* Tabs */}
          <div className="main-project-tabs">
            {["Our Projects", "Work Done"].map((tab) => (
              <button
                key={tab}
                className={`tab-button ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          {activeTab === "Our Projects" && (
            <>
              <h1 className="sectors-title">Our Projects</h1>
              {renderProjectCards(Projects.filter((p) => !p.completed))}
            </>
          )}

          {activeTab === "Work Done" && (
            <>
              <h1 className="sectors-title">Work Completed</h1>
              {renderProjectCards(Projects.filter((p) => p.completed), true)}
            </>
          )}
        </div>
      </div>

      {/* Global Components */}
      <LiveChat />
      <QAChatbot />
      <ScrollSocialIcons />
      <GetQuoteButton />
      <BackToTopButton />
      <Footer />
    </>
  );
};

export default Sectors;
